import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { InputComponent } from '../../../components/form/input/input.component';
import { ResolvableModal } from '../../abstraction/modal';
import { ReactiveFormsModule } from '@angular/forms';
import { MultilineInputComponent } from '../../../components/form/multiline-input/multiline-input.component';
import { SetFocusDirective } from '../../../directives/set-focus.directive';

@Component({
  selector: 'soft-input-modal',
  imports: [
    InputComponent,
    ReactiveFormsModule,
    MultilineInputComponent,
    SetFocusDirective,
  ],
  templateUrl: './input-modal.component.html',
  styleUrl: './input-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputModalComponent extends ResolvableModal<string> {
  textValue = model.required<string>();
  multiline = input<boolean>(false);
  placeholder = input<string>('Text');
  saveButtonText = input<string>('Speichern');
}
